<template>
  <div>
    <section class="section-padding blue-lt">
      <div class="wrap">
        <div class="grid-12">
          <h2>Set Your Recovery Objectives</h2>
        </div>
        <div class="grid-5">
          <p>How many hours can your business go without accessing its critical systems or servers?</p>
          <range-slider v-on:update-value="updateValue" model="recoveryTimeObjective" max="168" v-bind:value="recoveryTimeObjective"></range-slider>
        </div>
        <div class="grid-5 grid-offset-2">
          <p>How many hours of production time on those servers are you willing to lose?</p>
          <range-slider v-on:update-value="updateValue" model="recoveryPointObjective" v-bind:value="recoveryPointObjective" max="168"></range-slider>
        </div>
      </div>
    </section>
    <section class="section-padding blue-dk">
      <div class="wrap">
        <div class="grid-12">
          <h2>Recovery Process &amp; Data Storage</h2>
        </div>

          <div class="grid-5 justify-content">
            <p>How many gigabytes of data are on your critical business systems? Critical systems are the systems essential to your business operations.</p>
            <div class="row">
              <div class="grid-7">
                <input-number v-on:update-value="updateValue"  min="0" max="9999" v-bind:value="dataDisrupted"  v-model.number="dataDisrupted" label="GB" model="dataDisrupted"></input-number>
              </div>
            </div>
          </div>
          <div class="grid-5 grid-offset-2 justify-content">
            <p>How often do you currently back up these systems, e.g. what is the time between each backup? </p>
            <input-time v-on:update-value="updateValue" v-bind:value="timeBetweenBackups" model="timeBetweenBackups"></input-time>
          </div>


        <div class="grid-5 margin-top__lg">
          <p>How long does it take to initiate your recovery process? This is the amount of time that it will take you to prepare the systems for a recovery or restore.</p>
          <input-time v-on:update-value="updateValue" v-bind:value="timeInitiateBackup" model="timeInitiateBackup"></input-time>
        </div>
        <div class="grid-5 grid-offset-2 margin-top__lg">
          <p>Are you recovering data from a local network, or the cloud? This affects the speed at which the data can be recovered.</p>
          <input-switch v-on:update-value="updateValue" model="recoverySpeed" nameOne="local" nameTwo="cloud" labelOne="Local" labelTwo="Cloud" valueOne='716800' valueTwo='30720'></input-switch>
        </div>
      </div>
    </section>
    <section class="section-padding blue-lt">
      <div class="wrap">
        <div class="grid-12">
          <h2>Downtime &amp; Recovery Costs</h2>
        </div>

          <div class="grid-5 justify-content">
            <p>How many employees would be affected if your critical systems failed?</p>
            <range-slider v-on:update-value="updateValue" model="affectedEmployees" v-bind:value="affectedEmployees" max="1000"></range-slider>
          </div>
          <div class="grid-5 grid-offset-2 justify-content">
            <p>What is the revenue generated per hour by these employees?</p>
            <range-slider v-on:update-value="updateValue" model="businessLost" min="0" v-bind:value="businessLost" max="10000" v-bind:isDollar="true"></range-slider>
          </div>

        <div class="grid-5 margin-top__lg justify-content">
          <p>What is the average hourly wage of an employee using one of your critical systems?</p>
          <range-slider v-on:update-value="updateValue" model="averageWage" v-bind:value="averageWage" max="500" v-bind:isDollar="true"></range-slider>
        </div>
        <div class="grid-5 grid-offset-2 margin-top__lg justify-content">
          <p>What is the average hourly overhead cost of an employee using a critical system?</p>
          <range-slider v-on:update-value="updateValue" model="overheadCost" v-bind:value="overheadCost" min="0" max="500" v-bind:isDollar="true"></range-slider>
        </div>
      </div>
    </section>

    <results v-bind:recoveryTimeObjective="recoveryTimeObjective"
            v-bind:recoveryPointObjective="recoveryPointObjective"
            v-bind:dataDisrupted="dataDisrupted"
            v-bind:timeBetweenBackups="timeBetweenBackups"
            v-bind:timeInitiateBackup="timeInitiateBackup"
            v-bind:affectedEmployees="affectedEmployees"
            v-bind:averageWage="averageWage"
            v-bind:overheadCost="overheadCost"
            v-bind:businessLost="businessLost"
            v-bind:recoverySpeed="recoverySpeed"></results>
  </div>

</template>

<script>
import RangeSlider from './RangeSlider';
import InputTime from './InputTime';
import InputNumber from './InputNumber';
import InputSwitch from './InputSwitch';
import Results from './Results';
export default {
  name: 'calculator',
  components: {
    RangeSlider,
    InputTime,
    InputNumber,
    InputSwitch,
    Results
  },
  data() {
    return {
      recoveryTimeObjective: 84,
      recoveryPointObjective: 84,
      dataDisrupted: 250,
      timeBetweenBackups: 46080,
      timeInitiateBackup: 46080,
      affectedEmployees: 50,
      averageWage: 100,
      overheadCost: 100,
      businessLost: 1000,
      recoverySpeed: 716800,

    };
  },
  methods: {
    updateValue(model, value) {
      this[model] = Number(value)
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .blue-lt {
    background-color: #0C475D;
    position: relative;
    /*background-image: linear-gradient(-220deg, #0C475D 0%, #0B4054 31%, #0A3F53 33%, #073040 100%);*/
  }
  .blue-lt:after {
    content: '';
    display: block;
    position: absolute;
    top: -1.9vw;
    left: 0;
    border-width: 0px 50vw 2vw 0;
    border-style: solid;
    border-color: transparent transparent #0C475D transparent;
  }
  .blue-lt:before {
    content: '';
    display: block;
    position: absolute;
    bottom: -1.9vw;
    right: 0;
    z-index: 3;
    border-width: 0px 50vw 2vw 0vw;
    border-style: solid;
    border-color: transparent #0C475D transparent transparent;
  }

  .blue-dk {
    background-color: #002A3A;
    position: relative;
  }
  .blue-dk:after {
    content: '';
    display: block;
    position: absolute;
    top: -1.9vw;
    left: 0;
    border-width: 0px 50vw 2vw 0;
    border-style: solid;
    border-color: transparent transparent #002A3A transparent;
  }

  .blue-dk:before {
      content: '';
      display: block;
      position: absolute;
      bottom: -1.9vw;
      right: 0;
      z-index: 3;
      border-width: 0px 50vw 2vw 0vw;
      border-style: solid;
      border-color: transparent #002A3A transparent transparent;
    }
    .justify-content {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    }
</style>



// WEBPACK FOOTER //
// Calculator.vue?2bf4dc24